<template>
  <v-card>
    <v-toolbar flat height="50">
      <v-toolbar-title>Company Details</v-toolbar-title>
    </v-toolbar>
    <div v-if="employer" class="pa-4">
      <v-layout row wrap>
        <v-flex md5>
          <strong>Sponsor/Company name </strong><br />
          <p>{{ employer.name }}</p>
        </v-flex>
        <v-flex md3>
          <strong>ID Number</strong><br />
          <p>{{ employer.id_no}}</p>
        </v-flex>
        <v-flex md3>
          <strong>Address</strong><br />
          <p>{{ employer.address}}</p>
        </v-flex>
      </v-layout>
    </div>
  </v-card>
</template>

<script>
import {
  MEDICAL_STATUSES,
  VISA_TYPES,
  SERVICE_TYPES,
  PROJECT_OWNER,
} from "../../mdsir/const";

import {
  valueToText,
  getTV,
  districtTV,
  upazilaTV,
  unionTV,
} from "../../mdsir/MdsirUtils";

export default {
  props: ["employer"],
  data() {
    return {
      leftItems: [
        { title: "Name", key: "name" },
        { title: "Gender", key: "gender" },
        { title: "Passport", key: "passport_number" },
        { title: "NID", key: "nid_number" },
        { title: "Date of Birth", key: "dob" },
        { title: "Mobile", key: "mobile" },
        { title: "Email", key: "email" },
        { title: "Address", key: "address" },
        { title: "Training Start Date", key: "training_start_date" },
        { title: "Training End Date", key: "training_end_date" },
        { title: "Finger Status", key: "finger_status" },
        { title: "Notes", key: "notes" },
      ],
      rightItems: [
        { title: "Project Owner", key: "project_owner" },
        { title: "Contract Date", key: "contract_date" },
        { title: "Service Type", key: "service_type" },
        { title: "Flight Date", key: "flight_date" },
        { title: "Medical Date", key: "medical_date" },
        { title: "Medical Status", key: "medical_status" },
        { title: "Trade Name", key: "trade_name" },
        { title: "MOFA Date", key: "mofa_date" },
        { title: "MOFA Number", key: "mofa_number" },
        { title: "Visa Issue Date", key: "visa_issue_date" },
        { title: "Visa Number", key: "visa_number" },
        { title: "Visa ID Number", key: "visa_id_number" },
      ],
    };
  },

  // computed: {},

  methods: {
    renderProp(item) {
      const { key } = item;
      let value = this.project[key];
      switch (key) {
        case "medical_status":
          value = value ? valueToText(MEDICAL_STATUSES, value) : "";
          break;
        case "service_type":
          value = value ? valueToText(SERVICE_TYPES, value) : "";
          break;
        case "trade_name":
          value = value ? valueToText(VISA_TYPES, value) : "";
          break;
        case "project_owner":
          value = value ? valueToText(PROJECT_OWNER, value) : "";
          break;

        default:
          break;
      }
      return value;
    },
    districtTV: districtTV,
    upazilaTV: upazilaTV,
    unionTV: unionTV,
    getTV: getTV,
    valueToText: valueToText,
  },

  // mounted() {},

  // watch: {},

  // beforeDestroy() {},

  // created() {},
};
</script>
